// @ts-nocheck
import styled from 'styled-components';
import type { StatelessFunctionalComponent } from 'react';
import { getTheme } from 'settings/theme/index';

const {
  noodera: { spacing, fontTypes },
  palette: { neutral },
} = getTheme();
export const SocialMediaGroupIconsContainer: StatelessFunctionalComponent<any> = styled.div`
  display: flex;
  align-items: center;
  gap: ${spacing.x6};
  flex-wrap: wrap;
`;
export const TitleSocialMediaGroup: StatelessFunctionalComponent<any> = styled.div`
  ${fontTypes.font5Medium};
  color: ${neutral.eighty};
`;
export const ContainerSocialMediaGroup: StatelessFunctionalComponent<any> = styled.div`
  display: flex;
  gap: ${spacing.x5};
  margin-bottom: ${spacing.x3};
  flex-direction: ${(props) => props.flexDirection};
  align-items: ${(props) => (props.alignItems ? props.alignItems : 'center')};
`;
